import { useMemo } from "react";
import { buildHomeGraphSchema } from "@/lib/seo/schemas";
import { useStructuredData } from "./useStructuredData";

/** Ana sayfa — Organization + LocalBusiness + WebSite + FAQ */
export function useLocalBusinessSchema() {
  const schema = useMemo(() => buildHomeGraphSchema(), []);
  useStructuredData("schema-home", schema);
}
